import React from 'react';
import { motion } from 'framer-motion';
import { Link2Icon, QrCodeIcon, SmartphoneIcon, UserPlusIcon, CheckIcon } from 'lucide-react';
const webPoints = ['Open the invite link at join.kittypot.com', 'Add a spend or a receipt from the browser', 'See who owes who, settle up and confirm', 'Claim your name if someone added you already'];
const appPoints = ['Every kitty you are part of, plus My Balance', 'Invite from contacts, or by link, code and QR', 'Receipt scan, nudges and push notifications', 'Admin tools for the person running the pot'];
export function WaysToJoin() {
  const scrollToWaitlist = () => {
    document.getElementById('waitlist')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="ways-to-join" className="py-24 lg:py-32 bg-white" data-id="element-292" data-mp="2jips7jx0kxhp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293" data-mp="l4ed8tjyk3p1">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mb-12 lg:mb-16" data-id="element-294" data-mp="l5xvgpp6cotg">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-kitty-dark tracking-tight mb-4 leading-tight" data-id="element-295" data-mp="1ln14l0ccbpu0">
            Everyone can join, however they want
          </h2>
          <p className="text-lg text-gray-500" data-id="element-296" data-mp="1brr26bi15gfp">
            One person starts the kitty. Everyone else joins from a link in
            their browser or in the app — and the group is tracking spends
            within seconds.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6" data-id="element-297" data-mp="1zfqqz5vs6wrn">
          {/* Primary: browser join */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-3 rounded-3xl bg-kitty-yellow-50 border border-kitty-yellow-200 p-8 lg:p-10" data-id="element-298" data-mp="1ugxoe8i18q69">
            <div className="flex items-center gap-3 mb-6" data-id="element-299" data-mp="378h82c182xli">
              <div className="w-11 h-11 rounded-2xl bg-kitty-yellow flex items-center justify-center" data-id="element-300" data-mp="3b9kq956qt5pw">
                <Link2Icon className="w-5 h-5 text-kitty-dark" aria-hidden="true" data-id="element-301" data-mp="2x8gn6lnpg9f7" />
              </div>
              <div data-id="element-302" data-mp="327jukcr5qrqc">
                <p className="text-xs font-semibold uppercase tracking-widest text-kitty-yellow-700" data-id="element-303" data-mp="3271okoep0z58">
                  Fastest way in
                </p>
                <h3 className="text-2xl font-extrabold text-kitty-dark" data-id="element-304" data-mp="2saynzmzhp8ke">
                  Join from your browser
                </h3>
              </div>
            </div>

            <ul className="space-y-3 mb-8" data-id="element-305" data-mp="2eh7daba0vin3">
              {webPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-306" data-mp="2jimvzwoq9d2b">
                  <div className="mt-0.5 w-5 h-5 flex-shrink-0 rounded-full bg-kitty-dark flex items-center justify-center" data-id="element-307" data-mp="24kktlptfmxmn">
                    <CheckIcon className="w-3 h-3 text-kitty-yellow" aria-hidden="true" data-id="element-308" data-mp="29jfm5jh7c0jy" />
                  </div>
                  <span className="text-base text-gray-800 font-medium" data-id="element-309" data-mp="1pyfdza8e5iwx">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="flex flex-wrap items-center gap-4 text-sm font-semibold text-kitty-dark" data-id="element-310" data-mp="1zxcz036lyub6">
              <span className="inline-flex items-center gap-2" data-id="element-311" data-mp="1uw73xyph6uyh">
                <QrCodeIcon className="w-4 h-4" aria-hidden="true" data-id="element-312" data-mp="28wrp31iv52v5" />
                Link, code or QR
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-313" data-mp="24w7qrumjzt7f">
                <UserPlusIcon className="w-4 h-4" aria-hidden="true" data-id="element-314" data-mp="2imtdjuf4onal" />
                Name-only members welcome
              </span>
            </div>
          </motion.div>

          {/* Secondary: the app */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="lg:col-span-2 rounded-3xl bg-gray-950 p-8 lg:p-10 text-white flex flex-col" data-id="element-315" data-mp="2skr10fp5yg25">
            <div className="w-11 h-11 rounded-2xl bg-white/[0.08] flex items-center justify-center mb-6" data-id="element-316" data-mp="pw8zqvqfsu9j">
              <SmartphoneIcon className="w-5 h-5 text-kitty-yellow" aria-hidden="true" data-id="element-317" data-mp="ureixmsgfutx" />
            </div>
            <h3 className="text-2xl font-extrabold mb-2" data-id="element-318" data-mp="20ebt2ytuay1">The full app</h3>
            <p className="text-sm text-gray-400 mb-6" data-id="element-319" data-mp="227mctck9fbb">
              iOS and Android, currently in closed testing.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-320" data-mp="byu2j4txzi70">
              {appPoints.map(point => <li key={point} className="text-sm text-gray-300 leading-relaxed border-l-2 border-kitty-yellow/40 pl-3" data-id="element-321" data-mp="c0nbwrvxwgip">
                  {point}
                </li>)}
            </ul>

            <button onClick={scrollToWaitlist} className="mt-auto w-full bg-kitty-yellow text-kitty-dark py-3.5 rounded-full font-bold transition-colors duration-150 hover:bg-kitty-yellow-500 active:scale-[0.98]" data-id="element-322" data-mp="1nd7q08ks9vmi">
              Get on the testing list
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}